import NotificationIcon from "src/assets/icons/notification.svg";
import styles from "src/components/atoms/Notification/styles.module.css";

type Props = {
  handleClick: () => void;
  count: number;
};
export const Notification: React.FC<Props> = ({ handleClick, count }) => (
  <div className={styles.notification} onClick={handleClick} role="button">
    <img src={NotificationIcon} />
    {count ? <span>{count}</span> : null}
  </div>
);
